<template>
    <div class="ideas" v-if="videourl">
        <div class="container">
            <div class="ideas-box">
                <div class="content" v-html="text"></div>
                <div class="ideas-video-box">
                    <div class="video-content" v-if="videourl">
                        <iframe :src="parseUrl(videourl)"></iframe>
                    </div>
                    <div class="video-desc">
                        <div class="video-title">{{videotitle}}</div>
                        <div class="video-text" v-html="videotext"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="butterfly"></div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-home-ideas",

    data() {
        return {
            text: this.blockdata.text,
            videourl: this.blockdata.video_box.src,
            videotitle: this.blockdata.video_box.title,
            videotext: this.blockdata.video_box.text
        };
    },
    mounted: function() {},
    methods: {
        parseUrl: function(url) {
            return "//player.vimeo.com/video/" + url.split("/")[3];
        }
    }
};
</script>



// WEBPACK FOOTER //
// BlockHomeIdeas.vue?4ac306e8